import React from "react";

export const Pagination = () => {
  return (
    <div className="pagination-container">
      <div className="pagination">
        <p>
          <a href="/">VER MAS</a>
        </p>
        <p>
          <a href="/">PRIMER EQUIPO</a>
        </p>
        <p>
          <a href="/">FÚTBOL FEMENINO</a>
        </p>
        <p>
          <a href="/">CLUB</a>
        </p>
      </div>
    </div>
  );
};
